import React from 'react';
import { useViewport } from 'reactflow';
import type { SnapGuide } from './boardSnap';

interface BoardSnapGuidesProps {
  guides: SnapGuide[];
}

const BoardSnapGuides: React.FC<BoardSnapGuidesProps> = ({ guides }) => {
  const { x, y, zoom } = useViewport();
  if (guides.length === 0) return null;

  return (
    <svg className="board-snap-guides" aria-hidden>
      <g transform={`translate(${x} ${y}) scale(${zoom})`}>
        {guides.map((guide, i) =>
          guide.orientation === 'v' ? (
            <line
              key={`v-${i}-${guide.position}`}
              x1={guide.position}
              y1={guide.start}
              x2={guide.position}
              y2={guide.end}
            />
          ) : (
            <line
              key={`h-${i}-${guide.position}`}
              x1={guide.start}
              y1={guide.position}
              x2={guide.end}
              y2={guide.position}
            />
          ),
        )}
      </g>
    </svg>
  );
};

export default BoardSnapGuides;
